import { useState } from 'react';
import p_nav_previous from '../../Assets/Images/p_nav_previous.svg';
import service_alert from '../../Assets/Images/icons/service_alert.png';
import service_missed from '../../Assets/Images/icons/service_missed.png';
import reschedule from '../../Assets/Images/icons/reschedule.png';
import { getBookingList, getChatList } from '../../Services/api';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import p_appointment_right_arrow from "../../Assets/Images/p_appointment_right_arrow.svg";
import p_appointment_inStore from "../../Assets/Images/p_appointment_inStore.svg";
import axiosInstance from '../../Services/axios';
import inStore from "../../Assets/Images/In-Store.png";
import { FaStar } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
import AppointmentProductCard from '../../Components/appointment_card/AppointmentProductCard';
import AppointmentServiceCard from '../../Components/appointment_card/AppointmentServiceCard';
import ReactLoading from "react-loading";
import NodeaxiosInstance from '../../Services/nodeaxios';
import Lottie from 'lottie-react';
import emptyList from '../../Assets/lottieFiles/emptylist.json';
const BookingHistory = () => {

    const navigate = useNavigate();
    const [bookingDetails, setBookingDetails] = useState("");
    let [allAppointmentList, setAllAppointmentList] = useState([]);
    const [activeTab, setActiveTab] = useState("");
    const [allBookings, setAllBookings] = useState('')
    const [upcomingBookings, setUpcomingBookings] = useState([])
    const [completedBookings, setCompletedBookings] = useState([])
    const [expiredBookings, setExpiredBookings] = useState('')
    const [canelledBookings, setCancelledBookings] = useState('')
    const [bookingdetails, setbookingdetails] = useState([]);
    const [productRawData, setProductRawData] = useState([]);
    const [completedProduct, setCompletedProduct] = useState([])
    const [canelledProduct, setCancelledProduct] = useState([])
    const [allProduct, setAllProduct] = useState([])
    const [data, setData] = useState('')
    const [pageLoaded, setPageLoaded] = useState(false);
    const [serviceTab, setServiceTab] = useState('all');
    const [productTab, setProductTab] = useState('all');
    const valueParam = useParams();
    const locations = useLocation();
    const { vendor_type } = locations.state || {};



    useEffect(() => {
        getBookingDetails()
    }, []);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const getBookingDetails = async () => {
        const reqData = {
            "vendor_id": valueParam.vendor_id
        };
        NodeaxiosInstance.post('profile/my-merchant-history', reqData)
            .then((res) => {
                if (res.status == 200) {
                    setbookingdetails(res?.data?.history_details[0]?.history);
                    setProductRawData(res?.data?.history_details[1]?.history)

                    let data = res.data

                    setData(data)
                    let allProducts = []
                    let completedProducts = []
                    let canelledProducts = []

                    data.history_details.map((tabs) => {
                        if (tabs.tab == 'product') {
                            tabs.history.map((product) => {
                                if (product.order_status == "1") {
                                    allProducts.push(product)
                                }
                                else if (product.order_status == '2') {
                                    completedProducts.push(product)
                                }
                                else if (product.order_status == '3') {
                                    canelledProducts.push(product)
                                }
                            })
                        }
                    })
                    setCompletedProduct(completedProducts)
                    setCancelledProduct(canelledProducts)
                    setAllProduct([...allProducts, ...completedProducts, ...canelledProducts])
                    let allBookings = []
                    let upcomingBooking = []
                    let completedBookings = []
                    let expiredBookings = []
                    let cancelBookings = []

                    data.history_details.map((tabs) => {
                        if (tabs.tab == 'service') {
                            tabs.history.map((book) => {
                                if (book.book_status == '1') {
                                    allBookings.push(book)
                                    upcomingBooking.push(book)
                                } else if (book.book_status == '2') {
                                    allBookings.push(book)
                                    completedBookings.push(book)
                                }
                                else if (book.book_status == '6') {
                                    allBookings.push(book)
                                    expiredBookings.push(book)
                                }
                                else if (book.book_status == '4') {
                                    allBookings.push(book)
                                } else if (book.book_status == '3') {
                                    allBookings.push(book)
                                    cancelBookings.push(book)
                                }
                            })
                        }
                    })
                    setAllBookings(allBookings)
                    setCompletedBookings(completedBookings)
                    setUpcomingBookings(upcomingBooking)
                    setExpiredBookings(expiredBookings)
                    setCancelledBookings(cancelBookings)
                    const serviceOn = data?.vendor_details?.vendor_service_status == '1'
                    const productOn = data?.vendor_details?.vendor_product_status == '1'
                    const hasServices = allBookings.length > 0
                    const hasProducts = allProducts.length + completedProducts.length + canelledProducts.length > 0
                    if (serviceOn && (hasServices || !productOn || !hasProducts)) {
                        setActiveTab("services")
                    } else if (productOn) {
                        setActiveTab("products")
                    }
                    setPageLoaded(true)
                }
            })
            .catch(() => setPageLoaded(true))

    };

    const serviceOn = data?.vendor_details?.vendor_service_status == "1";
    const productOn = data?.vendor_details?.vendor_product_status == "1";

    const serviceTabs = [
        { key: 'all', label: 'All', list: allBookings, empty: 'No service appointments' },
        { key: 'upcoming', label: 'Upcoming', list: upcomingBookings, empty: 'No upcoming appointments' },
        { key: 'completed', label: 'Completed', list: completedBookings, empty: 'No completed appointments' },
        { key: 'cancelled', label: 'Cancelled', list: canelledBookings, empty: 'No cancelled appointments' },
        { key: 'expired', label: 'Expired', list: expiredBookings, empty: 'No expired appointments' },
    ];
    const productTabs = [
        { key: 'all', label: 'All', list: allProduct, empty: 'No Products' },
        { key: 'completed', label: 'Completed', list: completedProduct, empty: 'No Completed Products' },
        { key: 'cancelled', label: 'Cancelled', list: canelledProduct, empty: 'No Cancelled Products' },
    ];

    const renderSubTabs = (tabs, current, setCurrent) => (
        <ul className="appointmentFilter scroller-style-x nav nav-pills pt-2 pb-3 ff-poppins-regular" role="tablist">
            {tabs.map(t => (
                <li className="nav-item" role="presentation" key={t.key}>
                    <button
                        className={`nav-link ${current === t.key ? "active" : ""}`}
                        type="button"
                        role="tab"
                        aria-selected={current === t.key}
                        onClick={() => setCurrent(t.key)}
                    >
                        {t.label}
                    </button>
                </li>
            ))}
        </ul>
    );

    const renderEmpty = (text) => (
        <div className="d-flex flex-column align-items-center">
            <Lottie animationData={emptyList} loop style={{ width: "220px", height: "220px" }} />
            <div className="text-center ff-poppins-regular fs-14 secondary-text">{text}</div>
        </div>
    );

    const currentService = serviceTabs.find(t => t.key === serviceTab);
    const currentProduct = productTabs.find(t => t.key === productTab);

    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' onClick={() => navigate(-1)} />
                    <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>Booking History</div>
                </div>
            </div>
            <div className='mx-3 px-2 my-3 py-2'>
                <div className='ff-poppins-semiBold fs-20'>Booking</div>
                <div className='ff-poppins-regular fs-20'>History</div>
            </div>
            {
                pageLoaded ?
                    <div>
                        {serviceOn && productOn &&
                            <div className="d-flex justify-content-center history_page">
                                <ul className="nav nav-pills py-4" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "services" ? "active" : ""} rounded-start serviceBtnBM ff-poppins-regular`}
                                            type="button" role="tab"
                                            aria-selected={activeTab === "services"}
                                            onClick={() => handleTabClick("services")}
                                        >
                                            Services
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "products" ? "active" : ""} rounded-end productBtnBM ff-poppins-regular`}
                                            type="button" role="tab"
                                            aria-selected={activeTab === "products"}
                                            onClick={() => handleTabClick("products")}
                                        >
                                            Products
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        }

                        {serviceOn && activeTab === "services" &&
                            <div className="p-1">
                                {renderSubTabs(serviceTabs, serviceTab, setServiceTab)}
                                <div className='scroller-style-y'>
                                    <div style={{ paddingBottom: "300px" }}>
                                        {currentService.list.length > 0 ?
                                            currentService.list.map((item, i) => (
                                                <div key={item.booking_id || i}
                                                    onClick={() => navigate(`/details/${item.booking_id}`)}>
                                                    <AppointmentServiceCard data={item} />
                                                </div>
                                            )) :
                                            renderEmpty(currentService.empty)
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        {productOn && activeTab === "products" &&
                            <div className="p-1">
                                {renderSubTabs(productTabs, productTab, setProductTab)}
                                <div className='scroller-style-y'>
                                    <div style={{ paddingBottom: "300px" }}>
                                        {currentProduct.list.length > 0 ?
                                            currentProduct.list.map((item, i) => (
                                                <div key={item.order_id || i}
                                                    onClick={() => navigate(`/ProductPass/${item.order_id}`)}>
                                                    <AppointmentProductCard data={item} />
                                                </div>
                                            )) :
                                            renderEmpty(currentProduct.empty)
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        {!serviceOn && !productOn && renderEmpty("No history found")}
                    </div>
                    :
                    <div className=" ReactLoading">
                        <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} />
                    </div>
            }
        </>
    )
}

export default BookingHistory;
